module.exports = __webpack_public_path__ + "img/ico_rating_content_dialogue.248df885.png";